
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_o08jm_1jvxl_9",
  "action-slot": "awsui_action-slot_o08jm_1jvxl_41",
  "group-layout": "awsui_group-layout_o08jm_1jvxl_46",
  "group-layout-horizontal": "awsui_group-layout-horizontal_o08jm_1jvxl_50",
  "group-layout-vertical": "awsui_group-layout-vertical_o08jm_1jvxl_53",
  "controls": "awsui_controls_o08jm_1jvxl_57",
  "controls-horizontal": "awsui_controls-horizontal_o08jm_1jvxl_61",
  "controls-vertical": "awsui_controls-vertical_o08jm_1jvxl_65",
  "controls-invalid": "awsui_controls-invalid_o08jm_1jvxl_68",
  "controls-warning": "awsui_controls-warning_o08jm_1jvxl_68",
  "control": "awsui_control_o08jm_1jvxl_57",
  "control-middle-horizontal": "awsui_control-middle-horizontal_o08jm_1jvxl_76",
  "control-last-horizontal": "awsui_control-last-horizontal_o08jm_1jvxl_76",
  "control-middle-vertical": "awsui_control-middle-vertical_o08jm_1jvxl_79",
  "control-last-vertical": "awsui_control-last-vertical_o08jm_1jvxl_79",
  "inline-label": "awsui_inline-label_o08jm_1jvxl_88",
  "inline-label-wrapper": "awsui_inline-label-wrapper_o08jm_1jvxl_113",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_o08jm_1jvxl_118"
};
  